import React, { useState } from 'react';
import './css/OnlineExam.css';

// Reusing your standalone, modular layout components
import Navbar from './components/Navbar';
import Newsletter from './components/NewsLetter';
import Footer from './components/Footer';

// Import your custom images here
import examHeroBg from '../images/banner-psc.jpg';
import featureSectionBg from '../images/Banner2.png';
// import tabSectionBg from '../images/Banner2.png'; // Background for the new interactive tab section
import showcaseImage from '../images/PSCRight.png'; // Preview image for the right side

import twinBg from "../images/Banner3.png"; // New background image asset
import circle2Icon1 from "../images/HomeIcon.png"; // Icon for the first circle
import circle2Icon2 from "../images/HomeIcon.png"; // Icon for the second circle
import circle2Icon3 from "../images/CardImage1.png"; // Icon for the first circle
import circle2Icon4 from "../images/CardImage2.png"; // Icon for the second circle

import pscImg1 from "../images/psc1.jpg";
import pscImg2 from "../images/psc2.jpg";
import pscImg3 from "../images/psc3.jpg";
import pscImg4 from "../images/psc4.jpg";
import pscImg5 from "../images/psc5.jpg";
import pscImg6 from "../images/psc6.jpg";
import DownloadApp from './components/DownloadApp';

function PSC() {
    

    // State to control YouTube Video Popup Modal visibility
    const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

    

    return (
        <div className="online-exam-page-wrapper">

            {/* 1. Header Hero Section with integrated clean Navbar */}
            <section
                className="online-exam-hero-section"
                style={{ backgroundImage: `url(${examHeroBg})` }}
            >
                <Navbar />
            </section>

            {/* 3. New Interactive Tab & Video Showcase Section */}
            <section
                className="online-exam-interactive-section"
            // style={{ backgroundImage: `url(${tabSectionBg})` }}
            >
                <div className="container-fluid p-0">
                    <div className="row g-0 align-items-center">

                        {/* Left Part: 4 Tabs in a row with dynamic sub-description */}
                        <div className="col-lg-6 px-lg-5 py-5">
                            <div className="interactive-left-content">

                                <span
                                    className="interactive-mini-tag"
                                    style={{ color: '#083c66' }}
                                >
                                    PERFORMANCE SCORECARD
                                </span>

                                <h2
                                    className="interactive-heading"
                                    style={{ color: '#FBBB1B' }}
                                >
                                    Track Progress with Powerful Performance Insights
                                </h2>

                                <div
                                    className="zigzag-border mt-2 mb-4"
                                    style={{ backgroundColor: '#083c66' }}
                                ></div>

                                <p
                                    className="interactive-sub-text"
                                    style={{
                                        color: '#5c6770',
                                        fontSize: '1.05rem',
                                        lineHeight: '1.9',
                                        marginBottom: '0'
                                    }}
                                >
                                    Crestest's Performance Scorecard provides a comprehensive view of every
                                    student's academic journey through weighted performance indicators,
                                    subject-wise analysis, strength evaluation, overall progress tracking,
                                    and comparative performance trends. Interactive graphs and statistical
                                    insights help students identify strengths, focus on improvement areas,
                                    and make informed decisions to achieve consistent academic excellence.
                                </p>

                            </div>
                        </div>

                        {/* Right Part: Reduced image sizing cleanly centered with play button */}
                        <div className="col-lg-6 position-relative video-showcase-col">
                            <div className="video-bg-wrapper">
                                <img src={showcaseImage} alt="Platform Showcase Preview" className="showcase-img" />

                                {/* Center-aligned custom play button */}
                                <button
                                    className="custom-center-play-btn"
                                    onClick={() => setIsVideoModalOpen(true)}
                                    aria-label="Play video showcase"
                                >
                                    <span className="play-icon-triangle"></span>
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* Customized Premium Bordered Popup Modal for YouTube Video */}
            {isVideoModalOpen && (
                <div className="premium-video-modal-backdrop" onClick={() => setIsVideoModalOpen(false)}>
                    <div className="premium-video-modal-container" onClick={(e) => e.stopPropagation()}>
                        <button
                            className="premium-modal-close-btn"
                            onClick={() => setIsVideoModalOpen(false)}
                            aria-label="Close modal"
                        >
                            &times;
                        </button>
                        <div className="premium-video-frame-wrapper">
                            <iframe
                                className="youtube-iframe-embed"
                                src="https://www.youtube.com/embed/CAM1SWuvfgw?autoplay=1"
                                title="Platform Showcase Video"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                </div>
            )}

            {/* 2. Content Section matching style theme */}
            <section
                className="online-exam-content-section"
                style={{ backgroundImage: `url(${featureSectionBg})` }}
            >
                <div className="container py-5">
                    <div className="row justify-content-center text-center mb-5">
                        <div className="col-lg-8">
                            <span
                                className="grid-section-mini-tag"
                                style={{ color: "#083c66" }}
                            >
                                PERFORMANCE INSIGHTS
                            </span>

                            <h2
                                className="grid-section-heading"
                                style={{ color: "#FBBB1B" }}
                            >
                                Data-Driven Insights for Continuous Improvement
                            </h2>

                            <div
                                className="zigzag-border mx-auto mt-2"
                                style={{ backgroundColor: "#083c66" }}
                            ></div>
                        </div>
                    </div>

                    <div className="row g-4 justify-content-center">

                        {/* Card 1 */}
                        <div className="col-lg-4 col-md-6">
                            <div className="glass-grid-box text-center">
                                <img src={pscImg1} alt="Weighted Performance" className="grid-card-image mb-3" />

                                <div className="grid-box-text-block">
                                    <h4>Weighted Performance</h4>
                                    <p>
                                        Track scholastic efficiency through a weighted score calculated from
                                        Chapter Tests (10%), Module Tests (20%), and Mock Tests (70%).
                                        Color-coded indicators help students instantly understand their
                                        performance level and encourage continuous improvement.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Card 2 */}
                        <div className="col-lg-4 col-md-6">
                            <div className="glass-grid-box text-center">
                                <img src={pscImg2} alt="Strength Analysis" className="grid-card-image mb-3" />

                                <div className="grid-box-text-block">
                                    <h4>Strength Analysis</h4>
                                    <p>
                                        Detailed graphs and statistical analysis compare performances across
                                        Chapter, Module, and Mock Tests to identify strengths, weaknesses,
                                        and learning patterns for smarter preparation.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Card 3 */}
                        <div className="col-lg-4 col-md-6">
                            <div className="glass-grid-box text-center">
                                <img src={pscImg3} alt="Performance Analysis" className="grid-card-image mb-3" />

                                <div className="grid-box-text-block">
                                    <h4>Performance Analysis</h4>
                                    <p>
                                        Subject-wise bar and pie charts provide a comprehensive breakdown of
                                        attempted, unattempted, correct, and incorrect responses with
                                        detailed statistical insights.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Card 4 */}
                        <div className="col-lg-4 col-md-6">
                            <div className="glass-grid-box text-center">
                                <img src={pscImg4} alt="Overall Performance" className="grid-card-image mb-3" />

                                <div className="grid-box-text-block">
                                    <h4>Overall Performance</h4>
                                    <p>
                                        Evaluate your overall progress across practice sets with visual
                                        performance indicators and detailed response summaries that motivate
                                        steady improvement from one assessment to the next.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Card 5 */}
                        <div className="col-lg-4 col-md-6">
                            <div className="glass-grid-box text-center">
                                <img src={pscImg5} alt="Personal Score vs General Trend" className="grid-card-image mb-3" />

                                <div className="grid-box-text-block">
                                    <h4>Personal Score vs. General Trend</h4>
                                    <p>
                                        Compare your subject-wise competitive performance with the overall
                                        portal average through dynamic charts that help you understand your
                                        position and plan your next academic milestone.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Card 6 */}
                        <div className="col-lg-4 col-md-6">
                            <div className="glass-grid-box text-center">
                                <img src={pscImg6} alt="Score Comparison" className="grid-card-image mb-3" />

                                <div className="grid-box-text-block">
                                    <h4>Score Comparison</h4>
                                    <p>
                                        Compare multiple practice sets using interactive performance data
                                        and chapter-wise color-coded analysis to easily identify areas that
                                        require greater focus and improvement.
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* Download App Section */}
            <DownloadApp />

            {/* 4. NEW: Overlapping Dual Card Section */}
            <section
                className="twin-cards-section"
                style={{ backgroundImage: `url(${twinBg})` }}
            >
                <div className="container">

                    {/* Section Header (Center Aligned) */}
                    <div className="row justify-content-center text-center twin-header-margin">
                        <div className="col-lg-8 d-flex flex-column align-items-center">
                            <p className="cards-small-text" style={{ color: '#0f507a' }}>
                                SMART KNOWLEDGE CENTER
                            </p>

                            <h2 className="cards-main-heading" style={{ color: '#FBBB1B' }}>
                                Discover, Understand & Retain Every Concept
                            </h2>

                            <div
                                className="zigzag-border"
                                style={{ backgroundColor: '#0f507a' }}
                            ></div>
                        </div>

                    </div>

                    {/* Dual Cards Row */}
                    <div className="row g-5 justify-content-center twin-row-padding">

                        {/* Left Card */}
                        <div className="col-md-6 col-lg-5">
                            <div className="overlap-card">

                                {/* Floating Circle */}
                                <div className="floating-top-circle bg-circle-accent1">
                                    <img src={circle2Icon1} alt="E-Library" className="floating-circle-icon" />
                                </div>

                                {/* Card Content */}
                                <div className="overlap-card-body text-center d-flex flex-column align-items-center">
                                    <img
                                        src={circle2Icon3}
                                        alt="Online Exams Illustration"
                                        className="overlap-card-top-image"
                                    />

                                    <h4
                                        className="mb-3"
                                        style={{
                                            color: "#207AB4",
                                            fontWeight: "700",
                                            fontSize: "1.6rem",
                                            letterSpacing: "0.5px",
                                            textTransform: "capitalize"
                                        }}
                                    >
                                        Online Exams
                                    </h4>

                                    <p className="overlap-sub-text">
                                        Students are encouraged to begin their learning journey by taking online
                                        tests to assess their current academic knowledge. Based on their
                                        performance, they can choose the most suitable learning pathway,
                                        promoting a self-aware, learner-centric approach that fosters
                                        responsibility, continuous improvement, and meaningful learning beyond
                                        rote memorization.
                                    </p>

                                    <a
                                        href="/online-exams"
                                        className="overlap-colored-action text-decoration-none"
                                        style={{ color: "#207AB4" }}
                                    >
                                        EXPLORE ONLINE EXAMS
                                    </a>
                                </div>

                            </div>
                        </div>

                        {/* Right Card */}
                        <div className="col-md-6 col-lg-5">
                            <div className="overlap-card">

                                {/* Floating Circle */}
                                <div className="floating-top-circle bg-circle-accent2">
                                    <img
                                        src={circle2Icon2}
                                        alt="Performance Scorecard"
                                        className="floating-circle-icon"
                                    />
                                </div>

                                {/* Card Content */}
                                <div className="overlap-card-body text-center d-flex flex-column align-items-center">
                                    <img
                                        src={circle2Icon4}
                                        alt="E-Library Illustration"
                                        className="overlap-card-top-image"
                                    />

                                    <h4
                                        className="mb-3"
                                        style={{
                                            color: "#207AB4",
                                            fontWeight: "700",
                                            fontSize: "1.6rem",
                                            letterSpacing: "0.5px",
                                            textTransform: "capitalize"
                                        }}
                                    >
                                        E-Library
                                    </h4>

                                    <p className="overlap-sub-text">
                                        The clear and concise combination of concept maps and written notes
                                        promotes deeper understanding, better retention, and supports
                                        different learning styles. This enriched learning experience enhances
                                        students' ability to learn, retain, and recall concepts, helping
                                        them perform with confidence in both scholastic and competitive
                                        examinations.
                                    </p>

                                    <a
                                        href="/e-library"
                                        className="overlap-colored-action text-decoration-none"
                                        style={{ color: '#207AB4' }}
                                    >
                                        EXPLORE E-LIBRARY
                                    </a>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </section>





            {/* Bottom Global Components */}
            <Newsletter />
            <Footer />

        </div>
    );
}

export default PSC;

